import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Teleport as _Teleport, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d8fa4544")

_pushScopeId("data-v-d8fa4544")
const _hoisted_1 = /*#__PURE__*/_createVNode("h2", null, "カルテ項目の印刷イメージ", -1)
const _hoisted_2 = { class: "preview" }
const _hoisted_3 = { class: "section_header" }
const _hoisted_4 = { class: "karte_title" }
const _hoisted_5 = /*#__PURE__*/_createVNode("label", null, "カルテ : ", -1)
const _hoisted_6 = { class: "section_group" }
const _hoisted_7 = { class: "vue-flex-row button-frame" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("閉じる ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_karte_header_preview = _resolveComponent("karte-header-preview")
  const _component_karte_patient_header_preview = _resolveComponent("karte-patient-header-preview")
  const _component_karte_item_preview = _resolveComponent("karte-item-preview")
  const _component_vue_y_scroll_area = _resolveComponent("vue-y-scroll-area")
  const _component_normal_button = _resolveComponent("normal-button")
  const _component_white_backdrop = _resolveComponent("white-backdrop")

  return (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
    _createVNode(_component_white_backdrop, { show: _ctx.show }, {
      default: _withId(() => [
        _withDirectives(_createVNode("div", {
          class: ["frame", _ctx.$mq]
        }, [
          _hoisted_1,
          _createVNode(_component_vue_y_scroll_area, { class: "preview-scroll" }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_2, [
                _createVNode("section", _hoisted_3, [
                  _createVNode(_component_karte_header_preview, {
                    accountName: _ctx.accountName,
                    karteDateString: _ctx.karteDateString,
                    karteNumber: _ctx.karteNumber
                  }, null, 8, ["accountName", "karteDateString", "karteNumber"]),
                  _createVNode(_component_karte_patient_header_preview, { patient: _ctx.patient }, null, 8, ["patient"]),
                  _createVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createTextVNode(_toDisplayString(_ctx.title), 1)
                  ])
                ]),
                _createVNode("section", _hoisted_6, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.previewData, (item) => {
                    return (_openBlock(), _createBlock(_component_karte_item_preview, {
                      key: 'preview-' + item.id,
                      previewData: item
                    }, null, 8, ["previewData"]))
                  }), 128))
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_normal_button, {
              type: "button",
              class: "button",
              state: "confirm",
              onClick: _ctx.dismiss
            }, {
              default: _withId(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ], 2), [
          [_vShow, _ctx.show]
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
})